'use strict'

import { format, subDays, addDays } from 'date-fns';

const days = {
	'Monday—Friday': 1,
	'Tuesday—Saturday': 2,
	'Wednesday—Sunday': 3,
	'Thursday—Monday': 4,
	'Friday—Tuesday': 5,
	'Saturday—Wednesday': 6,
	'Sunday—Thursday': 0,
};

export const getTomorrowStr = dateStr => {

	const date = new Date(dateStr + ' 00:00:00');
	const tomorrow = new Date(date.getTime() + 86400000);

	return format(tomorrow, 'yyyy-MM-dd');
};

export const getYesterdayStr = dateStr => {

	const date = new Date(dateStr + ' 00:00:00');
	const yesterday = new Date(date.getTime() - 86400000);

	return format(yesterday, 'yyyy-MM-dd');
};

export const getWeekStartFromRef = (user, refDate) => {

	const { settings: { workWeek } } = user;

	const workWeekIdx = days[ workWeek ];
	const refDay = refDate.getDay();

	const diff = refDay - workWeekIdx;

	let weekStart = refDate;

	if (diff > 0) {
		weekStart = subDays(refDate, diff);

	} else if (diff < 0) {
		weekStart = subDays(refDate, 7 + diff);
	}

	return format(weekStart, 'yyyy-MM-dd');
};

export const dateFromIsoString = date => {
	return format(new Date(date), 'yyyy-MM-dd');
}

export const getWeekDates = date => {
	
	if (!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(date)) {
		return;
	}

	let curr = new Date(date + ' 00:00:00');
	let i = 5;
	const week = [ curr ];

	while (--i) {
		curr = addDays(curr, 1);
		week.push(curr);
	}

	return week;
};
